import React, { useState } from 'react';
import SvgIcon from '@/pages/home/components/SvgIcon';
import { Form, Input, Button } from 'tea-component';
import { isValidGsv } from '../_config/common';
import { MIN_PASSWORD_LEN, MAX_PASSWORD_LEN } from '../_config/constant';
import * as service from '@/pages/home/services/login';
import { useIntl } from 'umi';
import { encryptedInfo } from '@/pages/home/utils/frontEncryption';

export default function EmailResetPasswords(props: any) {
  const {
    valueEmail,
    token,
    onBack = () => console.log,
    onError = () => console.log,
  } = props;
  const { formatMessage } = useIntl();
  // 密码
  const [statusPadssword, setStatusPadssword] = useState<string | null>(null);
  const [valuePadssword, setValuePadssword] = useState<string>();
  // 再次输入密码
  const [statusPadsswordAgin, setStatusPadsswordAgin] = useState<string | null>(null);
  const [valuePadsswordAgin, setValuePadsswordAgin] = useState<string>();

  const [loading, setLoading] = useState(false);

  const onPadsswordChangClick = (val: string) => {
    setValuePadssword(val);
  };
  const onPadsswordBuleClick = () => {
    /** 密码Again有值时也同步规则判断 */
    if (valuePadsswordAgin) {
      onAginPadsswordBuleClick();
    }
    /** 密码Again有值时也同步规则判断 */
    if (!valuePadssword) {
      setStatusPadssword('dbh_login_no_password_enter');
      return false;
    }
    if (
      valuePadssword?.length < MIN_PASSWORD_LEN ||
      valuePadssword?.length > MAX_PASSWORD_LEN
    ) {
      setStatusPadssword('dbh_login_password_format');
      return false;
    }
    if (isValidGsv(valuePadssword)) {
      setStatusPadssword('dbh_login_format_gsv');
      return false;
    }
    setStatusPadssword(null);
    return true;
  };
  const getStatusPadsswordId = (id: string) => {
    if (id === 'dbh_login_password_format') {
      return formatMessage(
        { id },
        { min: MIN_PASSWORD_LEN, max: MAX_PASSWORD_LEN },
      );
    }
    return formatMessage({ id });
  };

  // 再次输入密码
  const onAginPadsswordChangClick = (val: string) => {
    setValuePadsswordAgin(val);
  };
  const onAginPadsswordBuleClick = () => {
    if (!valuePadsswordAgin) {
      setStatusPadsswordAgin('dbh_login_no_password_enter');
      return false;
    }
    if (valuePadsswordAgin === valuePadssword) {
      setStatusPadsswordAgin(null);
      return true;
    }
    setStatusPadsswordAgin('dbh_login_different_passwords');
    return false;
  };

  // 重置成功
  const [isSuccess, setIsSuccess] = useState(false);

  const changePassword = async () => {
    const _successPadssword = onPadsswordBuleClick();
    const _successPadsswordAgin = onAginPadsswordBuleClick();
    if (loading) {
      return;
    }
    if (!_successPadssword || !_successPadsswordAgin) {
      return;
    }
    setLoading(true);
    try {
      // 密码加密
      const turnPassword = await encryptedInfo(valuePadssword || '');
      await service.updatePassword({ token: token, password: turnPassword });
      setIsSuccess(true);
    } catch (err: any) {
      onError(err?.msg, err?.code);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-cont-email login-cont-email--resetpasswords">
      <div className="login-cont">
        <div className="login-cont-title">
          {' '}
          {formatMessage({ id: 'dbh_login_reset_passwords' })}
        </div>
        <div className="login-cont-email-icon">
          <SvgIcon
            className={isSuccess ? 'resetpasswords-success' : 'email-success'}
            type={isSuccess ? 'zhengque1' : 'youjianchenggong'}
          />
        </div>
        {isSuccess ? (
          <div className="login-cont-email-txt">
            {formatMessage({ id: 'dbh_login_reset_email_success' })}
          </div>
        ) : (
          <>
            <div className="login-cont-email-address">{valueEmail}</div>
            {/* 密码 */}
            <Form.Item
              label={formatMessage({ id: 'dbh_login_password' })}
              status={
                /* successPadssword ? 'success' : */ statusPadssword
                  ? 'error'
                  : undefined
              }
              message={
                statusPadssword
                  ? getStatusPadsswordId(statusPadssword)
                  : undefined
              }
            >
              <Input
                type="password"
                placeholder={formatMessage({
                  id: 'dbh_login_password_placeholder',
                })}
                value={valuePadssword}
                onChange={(val) => {
                  onPadsswordChangClick(val);
                }}
                onBlur={onPadsswordBuleClick}
              />
            </Form.Item>
            {/* 再次输入密码 */}
            <Form.Item
              label={formatMessage({ id: 'dbh_login_password_confirm' })}
              status={
                /* successPadsswordAgin ? 'success' : */ statusPadsswordAgin
                  ? 'error'
                  : undefined
              }
              message={
                statusPadsswordAgin
                  ? formatMessage({ id: statusPadsswordAgin })
                  : undefined
              }
            >
              <Input
                type="password"
                placeholder={formatMessage({
                  id: 'dbh_login_password_confirm_placeholder',
                })}
                value={valuePadsswordAgin}
                onChange={(val) => {
                  onAginPadsswordChangClick(val);
                }}
                onBlur={onAginPadsswordBuleClick}
              />
            </Form.Item>
          </>
        )}
        <div className="login-cont-from-btn">
          {isSuccess ? (
            <Button type="primary" onClick={onBack}>
              {formatMessage({ id: 'dbh_login_goback_tologin' })}
            </Button>
          ) : (
            <Button
              type="primary"
              onClick={() => {
                changePassword();
              }}
            >
              {formatMessage({ id: 'dbh_login_continue' })}
            </Button>
          )}
        </div>
      </div>
    </div>
  );
}
